import { useStore } from '@tanstack/react-form';
import { useFormContext } from './FormProvider';
import { FormField as SharedFormField, type FormFieldConfig } from '../common/forms/FormField';

interface FormFieldComponentProps {
  name: string;
  config: FormFieldConfig;
  /** Opts the field into §2 error-timing gating (see shared FormField). */
  gateErrors?: boolean;
}

export function FormField({ name, config, gateErrors = false }: FormFieldComponentProps) {
  const { form } = useFormContext();
  const submitted = useStore(form.store, (state) => state.submissionAttempts > 0);

  return (
    <form.Field name={name}>
      {(field) => (
        <SharedFormField
          field={field}
          config={config}
          submitted={gateErrors ? submitted : undefined}
        />
      )}
    </form.Field>
  );
}
